import React from "react";
import {
  Page,
  Navbar,
  Link,
  NavRight,
  Toolbar,
  BlockTitle,
  List,
  ListItem,
  Searchbar,
  theme  
} from "framework7-react";

const PageHome = () => {
  return (
    <Page>
      <Navbar className="text-4" title="Bidding">
      <NavRight>
        <Link
          searchbarEnable=".searchbar-demo"
          iconIos="f7:search"
          iconAurora="f7:search"
          iconMd="material:search"
        ></Link>
      </NavRight>
      <Searchbar
        className="searchbar-demo text-1"
        expandable
        searchContainer=".search-list"
        searchIn=".item-title"
        disableButton={!theme.aurora}
      ></Searchbar>
    </Navbar>
      <Toolbar tabbar noShadow bottom>
        <Link
          tabLink="#tab-1"
          text="Home"
          className="text-1"      
          iconIos="f7:home"
          iconAurora="f7:home"
          iconMd="material:home_outline"
        ></Link>
        <Link
          tabLink="#tab-2"
          tabLinkActive
          text="Search"      
          className="text-1" 
          iconIos="f7:search"
          iconAurora="f7:search"
          iconMd="material:search"     
        ></Link>
        <Link
          tabLink="#tab-3"
          text="Bids"      
          className="text-1"
          iconIos="f7:user"
          iconAurora="f7:user"
          iconMd="material:shopping_basket"           
        ></Link>
        <Link
          tabLink="#tab-3"
          text="Orders"      
          className="text-1"      
          iconIos="f7:user"
          iconAurora="f7:user"
          iconMd="material:local_mall"           
        ></Link>
        <Link
          tabLink="#tab-3"
          text="Profile"      
          className="text-1"
          iconIos="f7:user"
          iconAurora="f7:user"
          iconMd="material:person_outline"
        ></Link>
      </Toolbar>
      <BlockTitle>Navigation</BlockTitle>
      <List>
        <ListItem link="/login/" title="Login" />
        <ListItem link="/register/" title="Register" />
        <ListItem link="/about/" title="Bidding" />
        <ListItem link="/otpverify/" title="OTP Verify" />
        <ListItem link="/main/" title="Main" />        
      </List>
      <List>
        <ListItem
          link="/load-something-that-doesnt-exist/"
          title="Default Route (404)"
        />
      </List>      
    </Page>
  );
};
export default PageHome;